if (!customElements.get('pre-sale-controller')) {
  class PreSaleController extends HTMLElement {
    constructor () {
      super();
      this.buttons = this.querySelectorAll('.pre-sale-step');
      this.steps = this.querySelectorAll('[data-current-step]');
      this.currentStep = 1;
      this.lastStep = this.steps.length + 1;
      this.products = [];
      this.propertyKey = '_channel';
      for (const step of this.steps) {
        if (step.classList.contains('active-step')) {
          this.currentStep = step.getAttribute('data-current-step') * 1;
        }
      }
    }

    _getStepEl (step) {
      return this.querySelector(`*[data-current-step="${step}"]`);
    }

    _getSelectedRadio (step) {
      const stepEl = this._getStepEl(step);
      if (!stepEl) return null;
      return stepEl.querySelector('.variant-picker input[type="radio"]:checked');
    }

    _getOptionElForRadio (radio) {
      if (!radio) return null;
      return radio.closest('option-info') || radio.closest('.option-wrapper') || null;
    }

    variantChangedHandle (event) {
      const available = event?.detail?.variant?.available ?? true;
      this.changeButtonsStatus(1, available);
    }

    async _rehydrateGalleryIfStep1 () {
      try {
        if (this.currentStep !== 1) return;

        const pgc = this.querySelector('product-gallery-controller');
        if (!pgc) return;

        const galleryEl = pgc.querySelector('.product-gallery');
        const isVisible = !!(galleryEl && galleryEl.offsetParent !== null);

        if (!isVisible) return;

        if (typeof pgc._deactivateVariantBridge === 'function' && pgc._bridgeActive) {
          pgc._deactivateVariantBridge();
        }

        if (typeof pgc._swapHiddenToVideos === 'function') {
          pgc._swapHiddenToVideos();
        }
        if (typeof pgc._rehydrateMedia === 'function') {
          pgc._rehydrateMedia();
        }

        if (typeof pgc._initHeavy === 'function') {
          await pgc._initHeavy();
        }
      } catch (err) {
        console.warn('Rehydrate gallery failed:', err);
      }
    }

    changeButtonsStatus (step, available) {

      this.buttons.forEach((item) => {
        if (item.closest(`*[data-current-step="${step}"]`)) {
          if (item.classList.contains('pre-sale-cta')) {
            if (available) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          } else if (item.classList.contains('pre-sale-oos')) {
            if (available) {
              item.classList.add('hidden');
            } else {
              item.classList.remove('hidden');
            }
          }
        }
      });
    }

    productChangedHandle (event) {
      const available = event?.detail?.product?.available ?? true;
      const productID = event?.detail?.product?.id ?? null;
      if (productID) {
        this.latestStep2ProductId = productID;
        this.secondStepGalleryMedia = this.querySelectorAll(`*[data-current-step="2"] .product-gallery__media`);
        this.secondStepGalleryMedia.forEach((item) => {
          let itemProductID = item.getAttribute('data-product-id');
          if (itemProductID) {
            itemProductID = itemProductID * 1;
            if (productID === itemProductID) {
              item.style.display = 'block';
            } else {
              item.style.display = 'none';
            }
          }
        });
        const url = new URL(window.location.href);
        url.searchParams.set(`step2`, productID);
        window.history.replaceState({}, '', url);
      }
      this.changeButtonsStatus(2, available);
    }

    async getCart () {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error?.message ?? 'Unexpected error');
        }
        return await response.json();
      } catch (error) {
        throw error;
      }
    }

    async updateCart (items) {
      try {
        const updates = {
          'updates': items,
        };
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        });

        return await response.json();
      } catch (error) {
        console.error('Error:', error);
      }
    }

    async addToCart () {
      if (!this.products.length) {
        return;
      }
      const formData = {
        items: this.products.map((item) => {
          return {
            id: item,
            quantity: 1,
            properties: {
              [this.propertyKey]: 'pre-sale',
            },

          };
        }),
      };

      let data = null;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        data = await response.json();
      } catch (error) {
        console.error('Error:', error);
      }
      return data;
    }

    setFocus (item) {
      const scrollContainer = item.querySelector('.variant-picker__option-values');
      if (scrollContainer) {
        const focusedElement = item.querySelector('.variant-picker input[type="radio"]:checked');
        if (focusedElement) {
          setTimeout(() => {
            focusedElement.closest('.option-wrapper').scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
            });
          }, 50);
        }
      }
    }

    async clickHandle (e) {
      const button = e.target.closest('button');
      if (button && !button.classList.contains('pre-sale-oos')) {
        const prevState = this.currentStep;
        if (this.currentStep < this.lastStep) {
          this.currentStep = this.currentStep + 1;
        }
        this.steps.forEach((item) => {
          if (item.hasAttribute('data-current-step')) {
            const itemStep = item.getAttribute('data-current-step') * 1;
            if (itemStep === prevState) {
              const selectedVariant = item.querySelector('.variant-picker input[type="radio"]:checked');
              if (selectedVariant) {
                const variantID = selectedVariant.getAttribute('data-variant-id');
                const id = (itemStep === this.lastStep - 1)
                  ? selectedVariant.getAttribute('data-product-id')
                  : variantID;
                const url = new URL(window.location.href);
                url.searchParams.set(`step${prevState}`, id);
                if (url.search !== window.location.search) {
                  window.history.pushState({ step: prevState, id }, '', url);
                }
                if (!this.products.includes(variantID)) {
                  this.products.push(variantID);
                }
              }
            }
            if (this.currentStep !== this.lastStep) {
              if (itemStep === this.currentStep) {
                item.classList.add('active-step');
                this.setFocus(item);
              } else {
                item.classList.remove('active-step');
              }
            }
          }
        });
        if (this.currentStep === this.lastStep) {
          button.setAttribute('data-with-loading', '');
          const cart = await this.getCart();
          const cartItems = cart?.items ?? [];
          let toRemove = {};
          cartItems.forEach((cartItem) => {
            const properties = cartItem?.properties ?? {};
            const isPresale = Object.prototype.hasOwnProperty.call(properties, this.propertyKey);
            if (isPresale) {
              if (!toRemove.hasOwnProperty(cartItem.id)) {
                toRemove[cartItem.id] = 0;
              }
            }
          });
          if (Object.keys(toRemove).length) {
            await this.updateCart(toRemove);
          }
          const response = await this.addToCart();
          if (response !== null) {
            window.location.href = '/checkout';
          }
        }
      } else if (button) {
        this.oosClickHandle(e);
      }
    }

    oosClickHandle (e) {
      const btn = e.target.closest('button.pre-sale-oos');
      if (!btn) return;

      e.preventDefault();

      const stepEl = btn.closest('[data-current-step]');
      if (!stepEl) return;
      const stepNum = Number(stepEl.getAttribute('data-current-step')) || 1;

      const selectedRadio = this._getSelectedRadio(stepNum);
      if (!selectedRadio) return;

      const optionEl = this._getOptionElForRadio(selectedRadio) || stepEl;

      const searchScopes = [];

      searchScopes.push(optionEl);

      if (stepNum === 1) {
        const preSaleBlock = this.querySelector('[data-block-type="variant-picker-pre-sale"]');
        if (preSaleBlock) searchScopes.push(preSaleBlock);
      }

      const notifyBtn = this._findNotifyButton(searchScopes);
      if (notifyBtn) {
        notifyBtn.click();
        return;
      }

      this._waitForNotifyButton(searchScopes, 1000).then((lateBtn) => {
        if (lateBtn) lateBtn.click();
      });
    }

    _findNotifyButton (scopes = []) {
      for (const root of scopes) {
        if (!root) continue;
        const btn =
          root.querySelector('.restock-alerts-notify-button');
        if (btn) return btn;
      }
      return null;
    }

    _waitForNotifyButton (scopes = [], timeout = 1000) {
      return new Promise((resolve) => {
        const immediate = this._findNotifyButton(scopes);
        if (immediate) return resolve(immediate);

        const observers = [];
        let settled = false;

        const finish = (btn) => {
          if (settled) return;
          settled = true;
          observers.forEach((o) => o.disconnect());
          resolve(btn || null);
        };

        const targets = scopes.length ? scopes : [this];
        for (const target of targets) {
          const obs = new MutationObserver(() => {
            const found = this._findNotifyButton(scopes);
            if (found) finish(found);
          });
          obs.observe(target, { childList: true, subtree: true });
          observers.push(obs);
        }

        setTimeout(() => finish(null), timeout);
      });
    }

    async popstateHandle () {
      const url = new URL(window.location.href);
      const urlParams = url.searchParams;
      let step1Variant = urlParams.get('step1');
      let step2Product = urlParams.get('step2');
      this.currentStep = !step1Variant ? 1 : 2;

      this.products = [];
      if (step1Variant) {
        const variantInput = this.querySelector(`*[data-current-step="1"] .variant-picker input[data-variant-id="${step1Variant}"]`);
        if (variantInput) {
          if (variantInput.checked === true) {
            this.nativeRetoggleRadio(variantInput);
          } else {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change'));
          }
        }
      } else {
        const variantInput = this.querySelector(`*[data-current-step="1"] .variant-picker input[type="radio"]:checked`);
        if (variantInput) {
          step1Variant = variantInput.getAttribute('data-variant-id');
          this.nativeRetoggleRadio(variantInput);
        }
      }

      if (step1Variant && !this.products.includes(step1Variant)) {
        this.products.push(step1Variant);
      }

      if (step2Product) {
        if (this.currentStep === 1 && this.latestStep2ProductId) {
          if (step2Product !== String(this.latestStep2ProductId)) {
            url.searchParams.set('step2', this.latestStep2ProductId);
            step2Product = String(this.latestStep2ProductId);
            window.history.replaceState({ step: 1, id: this.latestStep2ProductId }, '', url);
          }
        }
        const variantInput = this.querySelector(`*[data-current-step="2"] .variant-picker input[data-product-id="${step2Product}"]`);
        if (variantInput) {
          if (variantInput.checked === true) {
            this.nativeRetoggleRadio(variantInput);
          } else {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change'));
          }
          if (this.currentStep === 2) {
            this.setFocus(this.querySelector('*[data-current-step="2"]'));
          }
        }
      } else {
        const variantInput = this.querySelector(`*[data-current-step="2"] .variant-picker input[type="radio"]:checked`);
        if (variantInput) {
          if (variantInput.checked === true) {
            this.nativeRetoggleRadio(variantInput);
          } else {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change'));
          }
          if (this.currentStep === 2) {
            this.setFocus(this.querySelector('*[data-current-step="2"]'));
          }
        }
      }

      this.steps.forEach(step => {
        const stepNum = parseInt(step.getAttribute('data-current-step'));
        step.classList.toggle('active-step', stepNum === this.currentStep);
      });
      await this._rehydrateGalleryIfStep1();
    }

    forceChange (input) {
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }

    nativeRetoggleRadio (target) {
      const name = target.name;
      const esc = (window.CSS && CSS.escape) ? CSS.escape(name) : name;
      const radios = this.querySelectorAll(`input[type="radio"][name="${esc}"]`);
      const alt = Array.from(radios).find(r => r !== target);
      if (alt) {
        alt.checked = true;
        alt.dispatchEvent(new Event('change', { bubbles: true }));
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      } else {

        this.forceChange(target);
      }
    }

    init () {
      const urlParams = new URLSearchParams(window.location.search);
      let step1Variant = urlParams.get('step1');
      let step2Product = urlParams.get('step2');

      if (step1Variant) {
        const variantInput = this.querySelector(`*[data-current-step="1"] .variant-picker input[data-variant-id="${step1Variant}"]`);
        if (variantInput) {
          if (variantInput.checked === true) {
            this.nativeRetoggleRadio(variantInput);
          } else {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change'));
          }
          if (!this.products.includes(step1Variant)) {
            this.products.push(step1Variant);
          }

          this.currentStep = 2;
          this.steps.forEach(step => {
            const stepNum = parseInt(step.getAttribute('data-current-step'));
            step.classList.toggle('active-step', stepNum === this.currentStep);
          });
        }
      }
      if (step2Product) {
        const variantInput = this.querySelector(`*[data-current-step="2"] .variant-picker input[data-product-id="${step2Product}"]`);
        if (variantInput) {
          if (variantInput.checked === true) {
            this.nativeRetoggleRadio(variantInput);
          } else {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change'));
          }
          if (this.currentStep === 2) {
            this.setFocus(this.querySelector('*[data-current-step="2"]'));
          }
        }
      }
    }

    connectedCallback () {
      document.addEventListener('VariantChanged', this.variantChangedHandle.bind(this));
      document.addEventListener('ProductChanged', this.productChangedHandle.bind(this));
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.clickHandle.bind(this));
      });
      window.addEventListener('popstate', this.popstateHandle.bind(this));
      this.init();
    }

    disconnectedCallback () {
      document.removeEventListener('VariantChanged', this.variantChangedHandle.bind(this));
      document.removeEventListener('ProductChanged', this.productChangedHandle.bind(this));
    }

  }

  customElements.define('pre-sale-controller', PreSaleController);
}

